__turbopack_context__.v({
  "xchain-circle-bot": "_8cyeqG_xchain-circle-bot",
  "xchain-circle-top": "_8cyeqG_xchain-circle-top",
  "xchain-connector-line-1": "_8cyeqG_xchain-connector-line-1",
  "xchainAnimationDelayed": "_8cyeqG_xchainAnimationDelayed",
  "xchainCircleBotRotation": "_8cyeqG_xchainCircleBotRotation",
  "xchainCircleOpacity": "_8cyeqG_xchainCircleOpacity",
  "xchainCircleTopRotation": "_8cyeqG_xchainCircleTopRotation",
  "xchainConnectorLine": "_8cyeqG_xchainConnectorLine",
});
